import { Component } from "@angular/core";

@Component({
    selector: 'max-header',
    templateUrl:'./header.component.html',
    styleUrls:['./header.component.css']
})
export class HeaderComponent {
    sticky: boolean = false;

    constructor(){}
}